import _ from 'lodash';
import React, { isValidElement } from 'react';
import classNames from 'classnames';
import { useValue, DataTestId } from '@jvs-group/jvs-mairistem-tools';
import { List, Menu } from "../..";
import CollectionListItemMenu from "./CollectionListItemMenu";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A collection list item can contain a set of items.
 *
 * @see CollectionListMenu
 */
var CollectionListItem = function CollectionListItem(props) {
  /**
   * Handle Update event.
   */
  var handleUpdate = function handleUpdate(event) {
    var item = props.item;
    var rest = getRest(CollectionListItem, props);
    _.invoke(props, 'onUpdate', event, item || rest);
  };

  /**
   * Handle Update item overrides props.
   */
  var handleUpdateOverrides = function handleUpdateOverrides(predefinedProps) {
    return {
      onClick: function onClick(event, buttonProps) {
        _.invoke(predefinedProps, 'onClick', event, buttonProps);
        handleUpdate(event);
      }
    };
  };

  /**
   * Handle Delete event.
   */
  var handleDelete = function handleDelete(event) {
    var item = props.item;
    var rest = getRest(CollectionListItem, props);
    _.invoke(props, 'onDelete', event, item || rest);
  };

  /**
   * Handle Delete item overrides props.
   */
  var handleDeleteOverrides = function handleDeleteOverrides(predefinedProps) {
    return {
      onClick: function onClick(event, buttonProps) {
        _.invoke(predefinedProps, 'onClick', event, buttonProps);
        handleDelete(event);
      }
    };
  };

  /**
   * Gestion du clic sur l'item.
   */
  var handleClick = function handleClick(event) {
    var onItemSelect = props.onItemSelect,
      item = props.item;
    if (!_.isNil(onItemSelect)) {
      onItemSelect(event, item);
    }
  };

  /**
   * Handle menu item overrides props.
   */
  var handleMenuItemOverrides = function handleMenuItemOverrides(predefinedProps) {
    return {
      onClick: function onClick(event) {
        var item = props.item;
        _.invoke(predefinedProps, 'onClick', event, item);
      }
    };
  };

  /**
   * Render the menu.
   */
  var renderMenu = function renderMenu() {
    var menu = props.menu,
      menuFirst = props.menuFirst,
      deleteItem = props.deleteItem,
      updateItem = props.updateItem,
      onDelete = props.onDelete,
      onUpdate = props.onUpdate;
    return !(_.isNil(menu) && _.isEmpty(menu) && _.isNil(onUpdate) && _.isNil(onDelete)) && /*#__PURE__*/_jsx(DataTestId.Accessor, {
      dataTestId: "collection-bouton-modifier",
      children: function children(dataTestIdUpdate) {
        return /*#__PURE__*/_jsx(DataTestId.Accessor, {
          dataTestId: "collection-bouton-supprimer",
          children: function children(dataTestIdDelete) {
            return /*#__PURE__*/_jsx(List.Content, {
              floated: "right",
              children: /*#__PURE__*/React.createElement(CollectionListItemMenu, {
                menuFirst: menuFirst
              }, [].concat(onUpdate
              // @ts-expect-error TODO: fix typing
              ? [Menu.Item.create(updateItem, {
                overrideProps: handleUpdateOverrides,
                defaultProps: {
                  'data-testid': dataTestIdUpdate
                }
              })] : [], onDelete
              // @ts-expect-error TODO: fix typing
              ? [Menu.Item.create(deleteItem, {
                overrideProps: handleDeleteOverrides,
                defaultProps: {
                  'data-testid': dataTestIdDelete
                }
              })] : [], _.map(menu || [], function (m) {
                return Menu.Item.create(m, {
                  overrideProps: handleMenuItemOverrides
                });
              })))
            });
          }
        });
      }
    });
  };

  /**
   * Render the component.
   */
  renderMenu.handledProps = [];
  var render = function render() {
    var children = props.children,
      content = props.content,
      className = props.className,
      control = props.control,
      item = props.item,
      size = props.size,
      icon = props.icon;
    var classes = classNames(useValue(size), className);
    var rest = getRest(CollectionListItem, props);
    if (!(_.isNil(children) || _.isEmpty(children))) {
      return /*#__PURE__*/_jsx(List.Item, Object.assign({}, rest, {
        className: classes,
        children: children
      }));
    }
    if (! /*#__PURE__*/isValidElement(content) && _.isPlainObject(content)) {
      return /*#__PURE__*/_jsxs(List.Item, Object.assign({}, rest, {
        className: classes,
        onClick: handleClick,
        children: [renderMenu(), List.Content.create(content)]
      }));
    }
    if (!_.isNil(control)) {
      return /*#__PURE__*/_jsxs(List.Item, Object.assign({}, rest, {
        className: classes,
        onClick: handleClick,
        children: [renderMenu(), List.Icon.create(icon), /*#__PURE__*/_jsx(List.Content, {
          children: /*#__PURE__*/React.createElement(control, item || rest)
        })]
      }));
    }
    return /*#__PURE__*/_jsxs(List.Item, Object.assign({}, rest, {
      className: classes,
      onClick: handleClick,
      children: [renderMenu(), List.Icon.create(icon), /*#__PURE__*/_jsx(List.Content, {
        children: content
      })]
    }));
  };
  render.handledProps = [];
  return render();
};

/**
 * Shorthand for CollectionListItemMenu.
 */
CollectionListItem.handledProps = ["deleteItem", "updateItem"];
CollectionListItem.Menu = CollectionListItemMenu;

/**
 * Default props.
 */
CollectionListItem.defaultProps = {
  deleteItem: 'Supprimer',
  updateItem: 'Modifier'
};
export default CollectionListItem;